import React, { Component } from 'react';
import styled from 'styled-components';
import Grid from 'components/Grid';
import scaleSize from 'utils/scale-size';
import getLocalized from 'utils/get-localized';
import { LIST_ITEMS_SIZE } from 'config';
import BackButton from './BackButton';
import withScrollHack from './HOCs/withScrollHack';

const ListGridWrapper = styled.div`
  width: ${scaleSize(1700)}px;
  height: ${scaleSize(1080)}px;
  margin-left: ${scaleSize(124)}px;
  position: relative;
`;

// Couplse of hacks to render collection with vertical and horizontal items
// with not terrible look
const StyledGrid = styled(Grid)`
  margin-top: ${scaleSize(57)}px;
  margin-left: ${({ useExtraOffset }) => scaleSize(useExtraOffset ? 96 : 0)}px;
`;

class ListGrid extends Component {
  onBack = () => {
    const { history } = this.props;

    history.goBack();
  };

  onFocus = (item, index) => {
    const ROW_SIZE = 4;
    const { items, match, loadExtraListItems } = this.props;
    const rows = items.length / ROW_SIZE;
    const currentRowIndex = Math.ceil(index / ROW_SIZE);
    const isRequiresExtraLoad = currentRowIndex >= rows - 1 - 1;
    const { listId } = match.params;
    if (isRequiresExtraLoad) loadExtraListItems(listId);
  };

  isMediumItemSize = () => {
    const { width, height } = this.props.itemSize;

    return LIST_ITEMS_SIZE.MEDIUM.width === width && LIST_ITEMS_SIZE.MEDIUM.height === height;
  };

  // TODO: Hack, fixes scroll with different sizes
  getRowSize = () => {
    const isMediumSize = this.isMediumItemSize();
    return isMediumSize ? 3 : 4;
  };

  render() {
    const { title, titles } = this.props;
    const gridTitle = getLocalized(titles, title);
    const rowSize = this.getRowSize();
    // offset needed only for vertical items
    const useExtraOffset = !this.isMediumItemSize();

    return (
      <>
        <BackButton onEnter={this.onBack} />
        <ListGridWrapper>
          <StyledGrid
            useExtraOffset={useExtraOffset}
            {...this.props}
            gridId="list-grid"
            onFocus={this.onFocus}
            title={gridTitle}
            rowSize={rowSize}
          />
        </ListGridWrapper>
      </>
    );
  }
}

export default withScrollHack(ListGrid);
